import React, { useRef } from "react";
import { handleShowSwalConfirmation } from "./Helper";
import { VALIDATION_MESSAGE } from "../Constants/Constants";
const $ = require('jquery')
interface parentRows {
  id: string;
  value: unknown;
}

// Pagination
export const paginationQuery = (pageIndex: any, pageSize: any, sorting: any, globalFilter: any, columnFilters: any, OtherValues: any = [], parentRows?: parentRows) => {

  $(".mytrackhide").addClass("d-none");
  $(".mytrackshow").removeClass("d-none");
  $(".mainPlayer").trigger('pause')
  let query: any = {
    page: pageIndex,
    pageSize: pageSize,
    orderBy: { field: sorting ? sorting[0]?.id : '' },
    search: globalFilter,
    orderDirection: (sorting.length > 0 ? sorting[0]?.desc ?  'ASC' :'DESC' : 'DESC'),
    columnFilters,
    parentRows
  }
  if (OtherValues && OtherValues?.length > 0) {
    OtherValues.forEach((d: any) => {
      query[d.key] = d.value;
    });
  }
  return query;
}


export const handleSearch = async (
  searching: any,
  // dispatch:any,  
  // dispatchAction:any, 
  // setPaginationState:any, 
  setIsError: any,
  setLoading: any,
  setIsRefetching: any,
  setSearchValue: any,
  // pagination:any, 
  // sorting:any, 
  // columnFilters:any
) => {
  if (!searching?.length) {
    setLoading(true);
    setIsError(false);
    setIsRefetching(true);
  } else {
    setIsRefetching(true);
  }
  try {
    if (searching?.length > 1) {
      setSearchValue(searching)
      setIsError(false);
      // let query = paginationQuery(
      //   pagination.pageIndex = 0,
      //   pagination.pageSize,
      //   sorting,
      //   searching,
      //   columnFilters,
      // )
      // await dispatch(dispatchAction(query));
    } else {
      if (!searching) {
        // let query = paginationQuery(
        //   pagination.pageIndex = 0,
        //   pagination.pageSize,
        //   sorting,
        //   '',
        //   columnFilters,
        // )
        setSearchValue('')
        // await dispatch(dispatchAction(query));
      }
    }
  }
  catch (error) {
    console.error('Error in handleSearch:', error);
    setIsError(true);
    return;
  }
  // setIsError(false);
  setLoading(false);
  setIsRefetching(false);
}

export const handleStatusChange = async (status_id: any, status: any, setData: any, setLoading: any, dispatch: any, dispatchAction: any) => {
  setLoading(true);

  let params = {
    "status_id": status_id,
    "status": status === 0 ? 1 : 0
  };

  await dispatch(dispatchAction(params));
  setData((prevData: any) => prevData.map((item: any) => {
    if (item.id === status_id) {
      return { ...item, status: status === 0 ? 1 : 0 };
    }
    return item;
  }));

  setLoading(false);
}

export const handleDeleteHelper = async (delete_id: any, setData: any, setLoading: any, dispatch: any, dispatchAction: any, isAsk = false) => {
  if (isAsk) {
    const isConfirm: any = await handleShowSwalConfirmation(VALIDATION_MESSAGE?.ARE_YOU_DELETE_ANY + " Warm up?", true)
    if (isConfirm) {
      setLoading(true);
      let params = {
        "delete_id": delete_id
      };
      await dispatch(dispatchAction(params));
      setData((prevData: any) => prevData.filter((item: any) => Number(item.id) !== Number(delete_id)));
      setLoading(false);
    }
  } else {
    setLoading(true);
    let params = {
      "delete_id": delete_id
    };
    await dispatch(dispatchAction(params));
    setData((prevData: any) => prevData.filter((item: any) => Number(item.id) !== Number(delete_id)));
    setLoading(false);
  }
}

export const handleStatusChangeUuid = async (status_id: any, status: any, setData: any, setLoading: any, dispatch: any, dispatchAction: any) => {
  setLoading(true);

  let params = {
    "status_id": status_id,
    "status": status === 0 ? 1 : 0
  };

  await dispatch(dispatchAction(params));
  setData((prevData: any) => prevData.map((item: any) => {
    if (item.uuid === status_id) {
      return { ...item, status: status === 0 ? 1 : 0 };
    }
    return item;
  }));

  setLoading(false);
}

export const toggleStatus = (currentStatus: any, setStatus: any) => {
  setStatus(currentStatus === 0 ? 1 : 0);
};


// export const getPriceHelper = (price: number | string) => {
//   return `$${price}`;

//   const priceString = typeof price === 'number' ? price.toFixed(2) : price != undefined ? price.toString() : '';
//   const parts = priceString.split('.');
//   if (parts.length === 1) {
//     return `$${parts[0]}`;
//   }
//   const integerPart = parts[0];
//   const decimalPart = parts[1].slice(0, 2)
//   let lastPrice = `$${integerPart}.${decimalPart}`;
//   return lastPrice

// }

export const getPriceHelper = (price: number | string) => {
  const priceString = typeof price === 'number' ? price.toFixed(2) : price != undefined ? price.toString() : '';
  const parts = priceString.split('.');
  if (parts.length === 1) {
    return `$${parts[0]}`;
  }
  const integerPart = parts[0];
  const decimalPart = parts[1].slice(0, 2)
  let lastPrice = `$${integerPart}.${decimalPart}`;
  return lastPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


export function getPaymentStatus(status:any) {
  if (status === 'complete' || status === 'succeeded') {
      return "Complete";
  } else {
      return "Expired";
  }
}

export function formatPaymentType(paymentType:any) {
  if (!paymentType) return "N/A";
  return paymentType.split('_').map((word:any) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
}


export const isNumber = (value:any) => {
  return !isNaN(value);
};//dev mm
